import React, { FC, useState, useEffect, memo, CSSProperties } from "react";
import { Tabs, Tab, withStyles } from "@material-ui/core";
import styles from "./Categories.module.scss";
import { SeccionedProduct } from "domains/catalog/aggregates/SeccionedProduct";
import { useKiosk } from "application/contexts/kiosk/KioskContext";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import DynamicIcon from "./components/dynamicIcon/DynamicIcon";
import { hexToRGBA } from "utils/utils";

const CustomTabs = withStyles({
  indicator: {
    display: "none",
  },
})(Tabs);

interface CategoriesProps {
  seccionedProdect: SeccionedProduct[];
  onClick: (index: number) => void;
  position?: number;
  hideCategory: boolean;
}

export const Categories: FC<CategoriesProps> = memo(
  ({ position, seccionedProdect, onClick, hideCategory }) => {
    const [categoriaIndex, setcategoriaIndex] = useState(position);
    const { kiosk } = useKiosk();
    const { resolution } = useScreenStore();

    useEffect(() => {
      setcategoriaIndex(position);
    }, [position]);

    if (!seccionedProdect) {
      return null;
    }

    return (
      <CustomTabs
        className={styles.Tabs}
        value={categoriaIndex}
        indicatorColor="primary"
        textColor="primary"
        onChange={(e, newValue) => {
          onClick(newValue);
          setcategoriaIndex(newValue);
        }}
        variant="scrollable"
        scrollButtons="off"
        orientation="vertical"
        style={{
          position: "relative",
          padding: resolution === ResolutionType.FULL_HD ? "0 16px" : "0 8px",
          minWidth:
            resolution === ResolutionType.FULL_HD
              ? hideCategory
                ? 85
                : 260
              : hideCategory
              ? 70
              : 210,
        }}
      >
        {seccionedProdect.map((category, index) => (
          <Tab
            key={category.id ?? index}
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
            classes={{
              selected: styles.customTabSelected,
              root: categoriaIndex === index ? styles.customTab : undefined,
            }}
            value={index}
            style={
              {
                "--color": hexToRGBA(kiosk?.themeColor ?? kiosk?.primaryColor ?? "#001537", 0.1),
                marginBottom: 8,
                minWidth: 0,
                width: hideCategory
                  ? resolution === ResolutionType.FULL_HD
                    ? 75
                    : 55
                  : undefined,
                padding: 6,
              } as CSSProperties
            }
            label={
              <div
                className={styles.Tab}
                style={
                  {
                    "--icon-color": kiosk?.themeColor ?? kiosk?.primaryColor,
                  } as CSSProperties
                }
              >
                <DynamicIcon
                  name={category?.categoryIcon ?? "more"}
                  size={resolution === ResolutionType.FULL_HD ? 60 : 40}
                />
                <p
                  style={{
                    width: hideCategory
                      ? 0
                      : resolution === ResolutionType.FULL_HD
                      ? 175
                      : 155,
                    transition: "all 0.5s ease",
                    fontSize: resolution === ResolutionType.FULL_HD ? 24 : 18,
                  }}
                >
                  {!hideCategory && category.title}
                </p>
              </div>
            }
          ></Tab>
        ))}
      </CustomTabs>
    );
  }
);
